module.exports = __webpack_public_path__ + "img/bb040d6.webp";